module.exports = __webpack_public_path__ + "static/boss2.b21306f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/boss2.png
// module id = 3047
// module chunks = 219286714057974